"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DwellingType = void 0;
var DwellingType;
(function (DwellingType) {
    DwellingType["SingleHome"] = "Single Family Home";
    DwellingType["Duplex"] = "Duplex";
    DwellingType["Triplex"] = "Triplex";
    DwellingType["Quadruplex"] = "Quadruplex";
    DwellingType["Condominium"] = "Condominium";
    DwellingType["Apartment"] = "Apartment";
    DwellingType["MultiFamily"] = "Multi Family 5+";
    DwellingType["Unknown"] = "Unknown";
    DwellingType["Townhouse"] = "Townhouse / Rowhouse";
    DwellingType["Mobile"] = "Mobile";
})(DwellingType = exports.DwellingType || (exports.DwellingType = {}));
